import { useState, useEffect, useMemo } from 'react';
import { DateTime } from 'luxon';
import { BufferLoader } from './BufferLoader';
// @ts-ignore
window.AudioContext = window.AudioContext || window.webkitAudioContext;
let sourcePlaying = {};
const audioBuffer = {};
const sources = {};
const timing = {};
export const AudioPlayer = ({ startTime, endTime, noiseEvents, isPlaying, position, playbackSpeed = 1, languageData, }) => {
    const audioContext = useMemo(() => new AudioContext(), []);
    const [playingList, updatePlayingList] = useState({});
    // Cleanup effect
    useEffect(() => {
        return () => {
            stopAll();
        };
    }, []);
    const addSource = (id) => {
        if (typeof sources[id] !== 'undefined') {
            sources[id] = null;
        }
        sources[id] = audioContext.createBufferSource();
        sources[id].buffer = audioBuffer[id];
        sources[id].playbackRate.value = playbackSpeed;
        sources[id].connect(audioContext.destination);
    };
    const playSound = (id, delay, start) => {
        addSource(id);
        sources[id].start(delay, start);
        sourcePlaying[id] = true;
        updatePlayingList(Object.assign({}, sourcePlaying));
    };
    const stopSound = (id) => {
        if (sourcePlaying[id]) {
            sources[id].stop();
            sources[id] = null;
            sourcePlaying[id] = false;
            updatePlayingList(Object.assign({}, sourcePlaying));
        }
        // create a new source so it's connected already
        addSource(id);
    };
    const finishedLoading = (bufferListLoaded) => {
        Object.values(bufferListLoaded).forEach(({ id, buffer }) => {
            audioBuffer[id] = buffer;
        });
    };
    const stopAll = () => {
        Object.entries(sourcePlaying).forEach(([id, playing]) => {
            if (playing) {
                stopSound(Number(id));
            }
        });
    };
    // setup audio context and buffer
    useEffect(() => {
        stopAll();
        sourcePlaying = {};
        noiseEvents.forEach(({ id, startTime, endTime }) => {
            const convertedStartTime = DateTime.fromISO(startTime).toSeconds();
            const convertedEndTime = DateTime.fromISO(endTime).toSeconds();
            timing[id] = { startTime: convertedStartTime, endTime: convertedEndTime };
            sourcePlaying[id] = false;
        });
        updatePlayingList(Object.assign({}, sourcePlaying));
        const extractAudioFilesInfo = noiseEvents.map(({ id, resourceUri: { authenticationScheme, uri } }) => {
            return {
                id,
                authenticationScheme,
                uri,
            };
        });
        const bufferLoader = new BufferLoader(audioContext, extractAudioFilesInfo, finishedLoading);
        bufferLoader.load(languageData);
    }, [noiseEvents]);
    useEffect(() => {
        if (isPlaying) {
            playAudio();
        }
    }, [position]);
    useEffect(() => {
        if (!isPlaying) {
            stopAll();
        }
    }, [isPlaying]);
    const playAudio = () => {
        Object.entries(sourcePlaying).forEach(([id, playing]) => {
            if (!playing) {
                if (position >= timing[id].startTime && position <= timing[id].endTime) {
                    playSound(Number(id), 0, position - timing[id].startTime);
                }
            }
            else {
                if (position > timing[id].endTime) {
                    stopSound(Number(id));
                }
            }
        });
        // at the end of track, stop all players
        if (endTime === position) {
            stopAll();
        }
    };
    return null;
    // Save for Debugging purposes
    // return (
    //   <>
    //     <table>
    //       <tbody>
    //         {Object.keys(playingList).map(id => (
    //           <tr key={id}>
    //             <td>🎵 {id}</td>
    //             <td>{sourcePlaying[id] ? `O` : `X`}</td>
    //           </tr>
    //         ))}
    //       </tbody>
    //     </table>
    //   </>
    // );
};
//# sourceMappingURL=AudioPlayer.js.map